import Navbar from 'Components/UI/Molecules/NavBar'
import Varies from 'Components/UI/Organisms/Settings/Various'
import Template from 'Components/UI/Templates/Common'

const Various = () => {
  return <Template navbar={<Navbar title="Configuración" subTitle="Varios" />} table={<Varies />} />
}
export default Various
